/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import "../../css/event211020.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event202207_ouma extends Component {
  state = {
    eventCode: 0,
    tabIndex: 3,
    slideIndex: 0,
    slidePlay: true,
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _google = () => {
    window.open("https://forms.gle/8Dp2hTPaLWRx5GFa6", "", "");
  };
  _go = () => {
    window.open("https://shop.aniplustv.com/", "", "");
  };
  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>우마무스메 오리지널 굿즈 온라인 예약 판매</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          {isMobile ? (
            <Fragment>
              {/*
                        <map name="Map1">
                            <area onClick={this._google} shape="rect" coords="36, 2809, 665, 2897" style={{ cursor: 'pointer'}}/>
                        </map>
                        */}
              <img
                src="/img/event/event220701/web_detail.jpg"
                onClick={this._go}
                style={{ cursor: "pointer" }}
              />
            </Fragment>
          ) : (
            <Fragment>
              {/*
                        <map name="Map2">
                            <area onClick={this._google} shape="rect" coords="218, 2399, 1493, 2516" style={{ cursor: 'pointer'}}/>
                        </map>
                        */}
              <img
                src="/img/event/event220701/web_detail.jpg"
                onClick={this._go}
                style={{ cursor: "pointer" }}
              />
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202207_ouma));
